/* Component in the LatestPage to display the post's data
 * Latest is a department choice in the Depts-Xtra app */
import React, { useEffect, useState } from "react"
import Card from "react-bootstrap/Card"

import styles from "../../styles/Post.module.css"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { Link, useHistory } from "react-router-dom"
import Avatar from "../../components/Avatar"
import { axiosInstance, axiosRes } from "../../api/axiosDefaults"
import { PostDropdown } from "../../components/PostDropdown"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import useHostName from "../../hooks/useHostName"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import { useSetImageContext } from '../../contexts/ImageContext'; 
import toast from "react-hot-toast";

const Latest = (props) => {
  const [showActionMenu, setShowActionMenu] = useState(true);
  const setImage = useSetImageContext();
  const {
    id,
    owner,
    name,
    profile_id,
    profile_image,
    departments,
    position,
    title,
    content,
    image1,
    updated_at,
  } = props

  const host = useHostName()
  const currentUser = useCurrentUser()
  const is_owner = currentUser?.username === owner
  const history = useHistory()

  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/latest/post/${id}/edit`
    )
  }

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosRes.delete(`/department/posts/${id}/`)
        toast.success(`Post Deleted`);
        history.goBack()
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/department/posts/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        history.goBack()
        toast.success(`Post Deleted Successfully!`);
      }
    } catch (err) {}
  }

  useEffect(() => {
      if (
        currentUser &&
        currentUser?.groups.length > 0 &&
        (currentUser?.groups[0]?.name === "Admincreative" ||
          currentUser?.groups[0]?.name === "Crew")
      ) {
        // now check where the post is His own post or NOT
        if (Number(profile_id) !== Number(currentUser?.profile_id)) {
          setShowActionMenu(false);
        }
      } else {
        if (
          currentUser &&
          currentUser?.groups.length > 0 &&
          currentUser?.groups[0]?.name === "Cast"
        ) {
          // Never show the menu
          setShowActionMenu(false);
        }
      }
    }, [profile_id, currentUser]);

  const handleClickFull1 = () => {
    setImage(image1); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };
  const [isImage1, setIsImage1] = useState(false);
  
  const getContentTypeWithGET = async (image1) => {
    const res = await fetch(image1, { method: 'GET', cache: 'no-store' });
    return res.headers.get('Content-Type');
  };

  const isImageFile = (fileType) => {
    const acceptedImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/tiff",
      "image/svg+xml",
    ];
    return acceptedImageTypes.includes(fileType);
  };

  useEffect(() => {
            if (image1) {
              getContentTypeWithGET(image1)
                .then((type) => {
                  const isImage1 = isImageFile(type);
                  setIsImage1(isImage1);
                  console.log(isImage1)
                  console.log(image1)
                })
                .catch((err) => {
                  setIsImage1(false);
                });
            } else {
              setIsImage1(false); 
            }
  
        }, [image1,]);

  return (
    <div>
    <Card className={`${styles.PostCard}`}>
    <Card.Body className={`py-0 px-0 ${styles.PostTop}`}>
    <Row className={`d-flex align-items-center my-0 py-0 py-sm-1`}>
    <Col xs={12} sm={3} className="my-0" >
          {/* small */}
          <div className='d-none d-sm-block'>
          <Row className='pt-1'>
          <Col xs={3} className="pl-3 pr-0">
            <Link
              to={`/${localStorage.getItem(
                "projectSlug"
              )}/profiles/${profile_id}`}
            >
              <Avatar src={profile_image} height={45} />
            </Link>
          </Col>
          <Col xs={9} className="pl-2 pr-0" >
          <div className={`${styles.Content4} pl-2 ml-3`}>
          <p className={`${styles.WhiteName}`}>{name}
          </p>
          <p className={`${styles.Posit}`}>{position}
          </p>
          </div>
          <div>
          </div>
          </Col>
          </Row>   
          </div>     
          {/* mobile */}
          <div className='d-sm-none'>
          <Row className='pb-0 mb-0'>
          <Col className="d-flex align-items-center" xs={2}>
              <Link
                to={`/${localStorage.getItem(
                  "projectSlug"
                )}/profiles/${profile_id}`}
              >
                <Avatar src={profile_image} height={40} />
              </Link>
            </Col>
          <Col xs={8} className="text-center" >
          <p className={`${styles.WhiteName}`}>{name}
          </p>
          <p className={`${styles.Posit}`}>{position}
          </p>
          <Row className={`${styles.Content3} my-0 mr-1 ml-1`}>
          <Col className='px-0 mx-0 text-center' xs={6}>
            {departments && <p style={{ textTransform: 'capitalize'}}>
              {departments}</p>}
          </Col>
           <Col className='px-0 mx-0 text-center' xs={6}>
            <p className={ `${styles.Date}`}> {updated_at}</p>
          </Col>
          </Row>
          </Col>
          <Col xs={2} 
          className="d-flex align-items-center" >
          {showActionMenu && (
          <PostDropdown
              handleEdit={handleEdit}
              handleDelete={handleDelete}
          />
          ) } 
          </Col>
          </Row> 
          </div> 
    </Col>    
    <Col xs={12} sm={6} className="text-center d-none d-sm-block" >
      <Row className={`${styles.Content3} my-0 mr-1 ml-1`}>
          <Col className='px-0 mx-0' xs={12}>
            {departments && <p style={{ textTransform: 'capitalize'}}>
              {departments}</p>}
          </Col>
      </Row>
    </Col> 
    {/* edit and date small */}
    <Col xs={12} sm={3} className="my-0 " >
      <div className='d-none d-sm-block'>
      <Row >
      <Col className="d-flex align-items-center" sm={9} >
      <p className={ `text-center  ${styles.Date}`}>{updated_at}
      </p>
      </Col>
      <Col sm={3}
      className="d-flex align-items-center px-0 float-right" >
        <div className={`${styles.Icon}`} >
      {showActionMenu && (
                <PostDropdown
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              )}
      </div>
      </Col>
      </Row>   
      </div>     
      </Col>                
    </Row>
    </Card.Body>
    <Card.Body className="pt-3" >
        {title && <h5 style={{ fontStyle: 'italic' }}
          className="text-center">{title}</h5>}
        <hr />
        {content && <Card.Text className={`${styles.Role}`}>{content}</Card.Text>}
    </Card.Body>
    <hr/>
    {/* image 1 */}
    <Row className='mb-2'>
    {image1 && (
    <Col xs={12} md={{span: 6, offset: 3}} className='mt-3 text-center' >
      <Card className="shadow-sm h-100 mx-3 mx-md-5">
      <Card.Body className={`text-center px-md-5 `}  >
        <p className={`${styles.BoldScene} mb-2`}>
            IMAGE 1</p>
        {isImage1 ? (
          <figure className="m-0 p-0 text-center">
            <Card.Img
              src={image1}
              alt={`image1`}
              className={styles.ImagesLand}
              style={{
                maxHeight: "300px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          </figure>
        ) : (
          <iframe
            src={image1}
            width="100%"
            title="depimage5"
                allow="fullscreen"
            height="300px"
            style={{
              border: "none",
              borderRadius: "8px",
              padding: "1rem",
            }}
          />
        )}
        </Card.Body>
        <Card.Body>
          <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
            onClick={() => handleClickFull1() }>FULLSIZE</p> 
        </Card.Body>
      </Card>
    </Col>
  )}  
    </Row >
    </Card>
  </div>
  )
}

export default Latest
